var _defs, _rect, _rect2, _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridSheen6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 120 80",
    preserveAspectRatio: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 6,
    height: 6,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0H0V6",
    fill: "none",
    stroke: "rgba(255,255,255,0.06)",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sheen",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "-10%",
    stopColor: "var(--color-primary, #1FE1FF)",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "var(--color-primary, #1FE1FF)",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "110%",
    stopColor: "var(--color-primary, #1FE1FF)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "blur"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 80,
    fill: "url(#grid)",
    rx: 6,
    ry: 6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 80,
    fill: "url(#sheen)",
    filter: "url(#blur)",
    rx: 6,
    ry: 6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "x",
    values: "-120;120",
    dur: "7s",
    repeatCount: "indefinite"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @media (prefers-reduced-motion: reduce) { animate { dur: 14s; } }\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridSheen6);
export default __webpack_public_path__ + "static/media/grid-sheen-6.ca0f1a253c6e1e3c83865c137a93c232.svg";
export { ForwardRef as ReactComponent };